module.exports = __webpack_public_path__ + "media/images/phone-black-18dp-65768d91ae47135e64380e2bcc0b9b38.svg";